import React from 'react';
import {IconNotFound} from "./../assets/images/icons";
import "./NotFound.scss";

export default function Logout() {
  return (
    <div className="not-found">
      <div className="page-not-found-content container">
        <img className="not-found-icon" src={IconNotFound} alt="astronomy icon"/>
        <h2 className="mb-4">Where to Spaced Traveller?</h2>
        <a href={`${process.env.REACT_APP_INVESTOR_APP_URL}`} className="me-3">
          <button className="page-not-found-button px-5">Home</button>
        </a>
        <a href={`${process.env.REACT_APP_INVESTOR_APP_URL}/login`}>
          <button className="page-not-found-button px-5">Login</button>
        </a>
      </div>
    </div>
  );
}
